import JohnsonCityHeroSection from "./components/HeroSection";
import JohnsonCityStickyNav from "./components/StickyNav";
import JohnsonCityProcessingTimeSection from "./components/ProcessingTimeSection";
import JohnsonCityServicesSection from "./components/ServicesSection";
import JohnsonCityLocalAreaSection from "./components/LocalAreaSection";
import JohnsonCityTravelTimingSection from "./components/TravelTimingSection";
import JohnsonCityDestinationsSection from "./components/DestinationsSection";
import JohnsonCityTestimonialsSection from "./components/TestimonialsSection";
import JohnsonCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JohnsonCityComparisonSection from "./components/ComparisonSection";
import JohnsonCityMistakesSection from "./components/MistakesSection";
import JohnsonCityHowItWorksSection from "./components/HowItWorksSection";
import JohnsonCityFAQSection, { faqs } from "./components/FAQSection";
import JohnsonCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JohnsonCityFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport Johnson City TN", description: "Urgent passport processing for Johnson City and Tri-Cities travelers with immediate international departure needs, as fast as 24 hours." },
  { name: "Expedited Passport Renewal Johnson City TN", description: "Fast passport renewal for ETSU faculty, Ballad Health professionals, and Washington County residents — 2-9 business days." },
  { name: "New Passport Johnson City TN", description: "First-time passport application assistance for Johnson City-area residents with acceptance facility scheduling support." },
  { name: "Child Passport Johnson City TN", description: "Minor passport services for Tri-Cities families, with parental consent guidance and step-by-step acceptance clerk support." },
  { name: "Lost Stolen Passport Replacement Johnson City TN", description: "Fast replacement of lost or stolen passports for Johnson City and Washington County residents." },
  { name: "ETSU Study Abroad Passport Johnson City TN", description: "Expedited passport processing for East Tennessee State University students with study-abroad program deadlines." },
];

export default function JohnsonCityPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Johnson City"
        state="Tennessee"
        stateAbbr="TN"
        route="/cities/johnson-city"
        title="Emergency & Expedited Passport Services Johnson City, TN — ETSU & Tri-Cities | Fast Passport Center"
        description="Emergency and expedited passport services in Johnson City, TN and Washington County — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving ETSU students, Ballad Health medical professionals, and Tri-Cities families. No Knoxville agency drive required."
        geoPlacename="Johnson City, Tennessee"
        geoPosition="36.3134;-82.3535"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Tennessee"
        statePageRoute="/states/tennessee"
      />
      <JohnsonCityHeroSection />
      <JohnsonCityStickyNav />
      <JohnsonCityProcessingTimeSection />
      <JohnsonCityServicesSection />
      <JohnsonCityLocalAreaSection />
      <JohnsonCityTravelTimingSection />
      <JohnsonCityDestinationsSection />
      <JohnsonCityTestimonialsSection />
      <JohnsonCityAcceptanceFacilitiesSection />
      <JohnsonCityComparisonSection />
      <JohnsonCityMistakesSection />
      <JohnsonCityHowItWorksSection />
      <JohnsonCityFAQSection />
      <JohnsonCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/johnson-city" state="TN" />
      <JohnsonCityFinalCTA />
    </div>
  );
}